import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';


class LanguageSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        onSelect: PropTypes.func.isRequired,
    };

    static defaultProps = {
        name: 'language',
        selectedLanguage: null,
        disabled: false,
        clearable: false,
        style: {width: '260px'}
    };

    constructor(props) {

        super(props);

        this.state = {
            selectedLanguage: (props.selectedLanguage) ? props.selectedLanguage : null
        };

        this.translate = this.props.baseData.translate;
        this.languages = this.props.baseData.languages;

        this.selectOption = this.selectOption.bind(this);

    }

    selectOption(item) {

        if (item) {
            const oldLanguage = this.state.selectedLanguage;

            if (item.value !== oldLanguage) {
                this.setState({selectedLanguage: item.value});

                if (this.props.onSelect) this.props.onSelect(item, this.props.name);
            }
        }

    }

    getOptions() {

        return (this.languages) ? this.languages.getLanguageTranslateOptions() : [];

    }

    render() {

        const {baseData, onSelect, selectedLanguage, options, onChange, value, placeholder, noResultsText, ...selectProps} = {...this.props};
        const opts = this.getOptions();
        const selectedOption = opts.find(o => o.value === String(this.state.selectedLanguage)) || null;

        return (
            <Select
                {...selectProps}
                className="chosen-container chosen-container-single"
                options={opts}
                onChange={this.selectOption}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                noResultsText={this.translate('noResultsFound')}
            />
        );

    }

}

export default LanguageSelector;